export default "/profile/images/ConnectiveOne.svg?41380e2f526961cb8799f52ef99dd2fc";